import { styled } from '@mui/material/styles';
import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';

export const BookmarkDialog = styled(Dialog, {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  padding: isMobile ? 0 : theme.spacing(4),
  zIndex: '1000 !important',
}));

export const BookmarkDialogTitle = styled(DialogTitle)({
  textAlign: 'center',
  fontSize: 16,
});

export const BookmarkDialogContent = styled(DialogContent)({
  // overflowY: 'none',
});

export const BookmarkContent = styled('div')({
  minHeight: 800,
});

export const SearchRow = styled('div')(({ theme }) => ({
  '& .MuiFormControl-root': {
    marginRight: theme.spacing(1),
    minWidth: 150,

    '&:nth-child(1)': {
      minWidth: 300,
    },
  },
}));

export const CloneBtn = styled('span')(({ theme }) => ({
  marginTop: theme.spacing(4),
  display: 'inline-block',
}));

export const TableContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(4),
  position: 'relative',
}));

export const TableHeader = styled('div')(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.action.disabled}`,
  fontWeight: 'bold',
  fontSize: 14,
  backgroundColor: theme.palette.action.disabledBackground,
}));

export const TableContent = styled('div')({});

export const TableRow = styled('div', {
  shouldForwardProp: (prop) => prop !== 'isMobile',
})(({ theme, isMobile }) => ({
  display: 'flex',
  position: 'relative',
  flexDirection: isMobile ? 'column' : 'row',
  paddingLeft: isMobile ? theme.spacing(5) : 0,
  justifyContent: 'center',
  marginBottom: isMobile ? theme.spacing(2) : 0,

  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    cursor: 'pointer',
  },
}));

export const Col = styled('div', {
  shouldForwardProp: (prop) => !['colIndex', 'isMobile', 'isText'].includes(prop),
})(({ theme, colIndex, isMobile, isText }) => {
  const widths = ['15%', '10%', '10%', '10%', '25%', '25%'];
  return {
    position: 'relative',
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    overflow: 'hidden',

    ...(isText && { fontSize: 13 }),

    ...(colIndex === 0 && {
      width: theme.spacing(5),
    }),
    ...(colIndex >= 1 && colIndex <= 6 && {
      width: isMobile ? '100%' : widths[colIndex - 1],
      ...(colIndex === 1 && { marginLeft: theme.spacing(5) }),
    }),

    '&.checkbox': {
      position: 'absolute',
      left: 0,
      height: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      display: 'flex',
    },

    '& .IMAGE': {
      margin: 2,
      marginBottom: 2,
    },
  };
});

export const BookmarkClose = styled(IconButton)(({ theme }) => ({
  fontSize: 15,
  color: theme.palette.text.primary,
  position: 'absolute',
  top: theme.spacing(1),
  left: theme.spacing(2),
}));
